<template>
  <LayoutRegistration
    :heading="heading"
  >
    <template #main>
      <div class="text-sm text-left">
        <p class="mb-4">On March 1, 2023, Unraid.net Accounts were migrated to a new identity provider – <a href="https://unraid.net/blog/unraid-net-account-upgrades" target="_blank" rel="noopener noreferrer" class="text-orange hover:text-orange-dark focus:text-orange-dark underline">Learn more</a>.</p>
        <p class="mb-4">As a result account management is no longer done via <abbr title="https://registration.unraid.net">this pop-up window URL</abbr>. Please follow these steps to experience our new account management system.</p>

        <ol class="opacity-90 list-decimal pl-4 space-y-2">
          <li v-if="CAN_POST_MESSAGE">Close this pop-up window</li>
          <li>Within the Unraid webgui go to Plugins</li>
          <li>Upgrade to the latest version of the Connect plugin (formly known as My Servers)</li>
          <li>After re-install reload the Unraid webgui</li>
          <li>
            Then just as before use the User Profile dropdown in the top right of the webgui – pop-ups should now load from <span class="font-mono">https://account.unraid.net</span>
            <ul class="list-disc mt-1 pl-4">
              <li>Sign in with your existing Unraid.net credentials</li>
              <li>Can't remember the account email? <router-link
                  :to="{ name: 'Troubleshoot' }"
                  class="text-orange hover:text-orange-dark focus:text-orange-dark underline"
                >{{ $t('contactSupport') }}</router-link>
              </li>
              <li>Don't have an account? You can sign up for an account</li>
            </ul>
          </li>
        </ol>

        <p class="mt-4">Thank you for your continued support.<br><span class="font-mono italic">– The Unraid Connect Team</span></p>

      </div>
    </template>
    <template v-if="CAN_POST_MESSAGE" #footer>
      <button
        @click="closePopUpFromPopUp()"
        class="mx-4 text-sm text-grey-lightest hover:text-white focus:text-white underline"
      >{{ $t('closePopUp') }}</button>
    </template>
  </LayoutRegistration>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { CAN_POST_MESSAGE } from '@/consts';
import LayoutRegistration from '../layouts/Registration.vue';

const heading = 'Deprecation Notice';

export default {
  name: 'ViewDeprecated',
  metaInfo: {
    title: heading,
  },
  components: {
    LayoutRegistration,
  },
  data: () => ({
    heading,
    copiedPlgUrl: false,
    CAN_POST_MESSAGE,
  }),
  computed: {
    ...mapGetters(['stateData']),
  },
  methods: {
    ...mapActions(['closePopUpFromPopUp']),
    async copyPlg() {
      await navigator.clipboard.writeText('https://sfo2.digitaloceanspaces.com/unraid-dl/unraid-api/dynamix.unraid.net.plg');
      this.copiedPlgUrl = true;
      setTimeout(() => {
        this.copiedPlgUrl = false;
      }, 1000);
      return true;
    },
  },
};
</script>

<style lang="postcss">
code {
  @apply text-black bg-grey p-1 rounded leading-none;
}
</style>
